import styled from "styled-components";

export const MessageContainerDiv = styled.div`
    bottom: 16px;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    z-index: 10;
`;
